import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/kit";
import { LogOut, User } from "lucide-react";

export default function Profile() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="space-y-6 fade-in">
      <div>
        <div className="hsc-label">Coach</div>
        <h1 className="font-display text-3xl text-white">Profil</h1>
      </div>
      <div className="rounded-2xl border border-[#1F1F22] bg-[#0A0A0C] p-6 text-center">
        <div className="mx-auto mb-3 flex h-16 w-16 items-center justify-center rounded-full bg-[#141416]"><User className="h-7 w-7 text-[#8E8E93]" /></div>
        <div className="font-display text-xl text-white">{user.name}</div>
        <div className="text-[12px] text-[#6E6E73]">{user.email}</div>
        <div className="mt-2 text-[11px] uppercase tracking-widest text-[#8FD3E8]">Coach</div>
      </div>
      <Button variant="danger" className="w-full" onClick={() => { logout(); navigate("/login", { replace: true }); }} data-testid="coach-logout">
        <LogOut className="h-4 w-4" /> Keluar
      </Button>
    </div>
  );
}
